module.exports = __webpack_public_path__ + "img/alfie-about-we-love-what-we-do.43ba37e2.jpg";